/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Form from '@organisms/Form';

import DocumentSelect from '../DocumentSelect';

const DocumentField = ({ name, label, rules, ...props }) => (
  <Form.Item name={name} label={label} rules={rules}>
    <DocumentSelect {...props} />
  </Form.Item>
);

export default DocumentField;
